import { Component } from "react";
import { Card } from "semantic-ui-react";
import { useReferenceInfo } from "../../providers/ReferenceInfoProvider";

const TermsOfUseColumn2 = () => {
	const { currentInfo } = useReferenceInfo();
	return (
		<Card fluid>
			<Card.Content>
				<h4 className="title-card">&nbsp;</h4>
			</Card.Content>
			<Card.Content>
				<ol start={4}
				  style={{
						paddingLeft: 0,
						marginLeft: 12,
						marginTop: 0,
						// listStyle: "none",
					}}				
				>
					<li>
						Commercial Use
						<p>
							Commercial use of ESVD data is subject to separate terms and conditions. 
							Users intending to utilize ESVD data for commercial purposes must report such usage and become a strategic partner of ESVD. 
							Strategic partners will be acknowledged on the ESVD website and may collaborate in projects and presentations. 
							The Foundation for Sustainable Development reserves the right to refuse commercial use of ESVD data at its discretion.
						</p><br/>
					</li>
					<li>
						Compliance with Dutch Law
						<p>
							While the Ecosystem Services Valuation Database (ESVD) aims to be a global representation of ecosystem services valuation data, 
							it is important to note that the Foundation for Sustainable Development (FSD) is based in the Netherlands. 
							As such, all users of ESVD are required to comply with Dutch law regarding data usage, including but not limited to privacy laws and intellectual property rights. 
							Users acknowledge that any disputes arising from the use of ESVD shall be governed by Dutch law and subject to the jurisdiction of Dutch courts.
						</p><br/>
					</li>
					<li>
						Limitation of Liability
						<p>
							In no event shall the Foundation for Sustainable Development, its affiliates, agents, or collaborators be liable for any damages, 
							including without limitation, direct or indirect, special or incidental, moral or consequential, 
							arising in connection with your use of the ESVD, its information, or derivatives thereof.								
						</p>
						<br/>
					</li>
					<li>
						Modification of Terms
						<p>
							The Foundation for Sustainable Development reserves the right to modify these terms of use at any time without prior notice. 
							Users are responsible for regularly reviewing the terms for any updates or changes.
											
						</p>
					</li>

				</ol>
		
			</Card.Content>
		</Card>
	);
};

export default TermsOfUseColumn2;
